var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcommerce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ecommerce",
    transform: "translate(-307 -181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 32,
    height: 32,
    transform: "translate(307 181)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "ecommerce_1_",
    "data-name": "ecommerce (1)",
    transform: "translate(309 178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M191,154.609h6.356L198.3,151H191Z",
    transform: "translate(-180.556 -138.016)",
    fill: "#00c5d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M24.66,5H3.338A3.341,3.341,0,0,0,0,8.338V23.373H28V8.338A3.341,3.341,0,0,0,24.66,5ZM11.374,21.514H10.062a.82.82,0,0,1,0-1.64h1.312a.82.82,0,1,1,0,1.64Zm5.687,0H15.748a.82.82,0,1,1,0-1.64h1.312a.82.82,0,0,1,0,1.64Zm2.411-8.639L18.3,17.322a1.223,1.223,0,0,1-1.182.912h-7.1A1.224,1.224,0,0,1,8.8,17.011V10.14H7.031a.82.82,0,0,1,0-1.64H9.624a.821.821,0,0,1,.82.82v2.023H18.29A1.222,1.222,0,0,1,19.472,12.875Z",
    transform: "translate(0)",
    fill: "#00c5d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M3.338,374.5h5.39v2.3h-2.6a.82.82,0,0,0,0,1.641H21.873a.82.82,0,0,0,0-1.641h-2.6v-2.3h5.39A3.345,3.345,0,0,0,28,371H0A3.347,3.347,0,0,0,3.338,374.5Z",
    transform: "translate(0 -345.986)",
    fill: "#00c5d9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.693bc99a0de7bb5257a90ecbc16e6d79.svg";
export { ForwardRef as ReactComponent };